import { IconFlame, IconX, IconInstagram } from './icons'

const INSTAGRAM_URL = 'https://www.instagram.com/actionthemoviegame/'

const HOUSE_SVG = (
  <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
  </svg>
)
const PLAY_SVG = (
  <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
    <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 12.5v-9l6 4.5-6 4.5z" />
  </svg>
)
const PEOPLE_SVG = (
  <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
  </svg>
)
const USER_SVG = (
  <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
  </svg>
)
const GEAR_SVG = (
  <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
    <path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z" />
  </svg>
)
// Clean line (stroke) book icon for How to Play — no emoji.
const BOOK_SVG = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="22" height="22">
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
  </svg>
)

// id → nav target (passed to onNavigate). activeFor lists the gameStates that
// should highlight the row. "Single Player" keeps the old "play" route.
const LINKS = [
  { id: 'home',        label: 'Home',          icon: HOUSE_SVG,  activeFor: ['home'] },
  { id: 'play',        label: 'Single Player', icon: PLAY_SVG,   activeFor: ['single-player', 'setup', 'playing', 'won', 'daily', 'film-review', 'historical'] },
  { id: 'multiplayer', label: 'Multiplayer',   icon: PEOPLE_SVG, activeFor: ['multiplayer', 'mp-lobby', 'coop-gameplay', 'h2h-pick', 'h2h-reveal', 'h2h-waiting', 'h2h-results', 'h2h-actor-pick', 'h2h-get-ready', 'party-mode-select'] },
  { id: 'profile',     label: 'Profile',       icon: USER_SVG,   activeFor: ['profile'] },
  { id: 'settings',    label: 'Settings',      icon: GEAR_SVG,   activeFor: ['settings'] },
  { id: 'how-to-play', label: 'How to Play',   icon: BOOK_SVG,   activeFor: ['how-to-play'] },
]

export default function SideMenu({ open, onClose, onNavigate, user, currentUser, currentStreak = 0, activeState }) {
  const handleClick = (id) => {
    onClose()
    onNavigate(id)
  }

  const avatar   = user?.avatar
  const username = user?.username || currentUser?.email?.split('@')[0] || 'Guest'

  return (
    <>
      <div
        className={`side-menu__scrim${open ? ' side-menu__scrim--open' : ''}`}
        onClick={onClose}
        aria-hidden="true"
      />
      <aside
        className={`side-menu${open ? ' side-menu--open' : ''}`}
        role="dialog"
        aria-label="Main menu"
        aria-hidden={!open}
      >
        <div className="side-menu__top">
          <div className="side-menu__user">
            <div className="side-menu__avatar">
              <img
                src={avatar || '/clapperboard.png'}
                alt=""
                onError={(e) => { if (!e.currentTarget.src.endsWith('/clapperboard.png')) e.currentTarget.src = '/clapperboard.png' }}
              />
            </div>
            <div className="side-menu__user-info">
              <span className="side-menu__username">{username}</span>
              <span className="side-menu__streak"><IconFlame size={14} color="var(--accent-gold)" style={{ verticalAlign: 'middle' }} /> {currentStreak}-day streak</span>
            </div>
          </div>
          <button
            type="button"
            className="side-menu__close"
            onClick={onClose}
            aria-label="Close menu"
          >
            <IconX size={16} />
          </button>
        </div>

        <nav className="side-menu__nav">
          {LINKS.map((l) => {
            const active = l.activeFor.includes(activeState)
            return (
              <button
                key={l.id}
                type="button"
                className={`side-menu__link${active ? ' side-menu__link--active' : ''}`}
                onClick={() => handleClick(l.id)}
                aria-current={active ? 'page' : undefined}
              >
                <span className="side-menu__link-icon" aria-hidden="true">{l.icon}</span>
                <span className="side-menu__link-label">{l.label}</span>
                <span className="side-menu__link-chevron" aria-hidden="true">›</span>
              </button>
            )
          })}
        </nav>

        <div className="nav-social">
          <div className="nav-social__label">Follow the Show</div>
          <a
            className="nav-social__tile"
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <IconInstagram size={24} />
          </a>
        </div>
      </aside>
    </>
  )
}
